/**
 * @flow
 * @relayHash e6306feb1898488384e5286324108a37
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InvalidateTradeSummariesMutationVariables = {|
  accountId: string,
  portfolioId?: ?string,
  regenerate?: ?boolean,
|};
export type InvalidateTradeSummariesMutationResponse = {|
  +invalidateTradeSummaries: ?{|
    +success: ?boolean
  |}
|};
export type InvalidateTradeSummariesMutation = {|
  variables: InvalidateTradeSummariesMutationVariables,
  response: InvalidateTradeSummariesMutationResponse,
|};
*/


/*
mutation InvalidateTradeSummariesMutation(
  $accountId: ID!
  $portfolioId: ID
  $regenerate: Boolean
) {
  invalidateTradeSummaries(accountId: $accountId, portfolioId: $portfolioId, regenerate: $regenerate) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "accountId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "portfolioId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "regenerate",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "invalidateTradeSummaries",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "portfolioId",
        "variableName": "portfolioId"
      },
      {
        "kind": "Variable",
        "name": "regenerate",
        "variableName": "regenerate"
      }
    ],
    "concreteType": "InvalidateTradeSummaries",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "InvalidateTradeSummariesMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "InvalidateTradeSummariesMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "InvalidateTradeSummariesMutation",
    "id": null,
    "text": "mutation InvalidateTradeSummariesMutation(\n  $accountId: ID!\n  $portfolioId: ID\n  $regenerate: Boolean\n) {\n  invalidateTradeSummaries(accountId: $accountId, portfolioId: $portfolioId, regenerate: $regenerate) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '59f9b6b428e5b0e5cec78443c391d029';
module.exports = node;
